import * as t from "io-ts"
import { AnswerAttachmentContentType } from "../../answer-attachment-content-type";

export const AttachmentBuffer = t.type({
    data: t.array(t.number)
})

export const Attachment = t.type({
    type: AnswerAttachmentContentType,
    buffer: AttachmentBuffer
});
export type Attachment = t.TypeOf<typeof Attachment>;